<template>
  <v-dialog
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
    :max-width="maxWidth"
    :persistent="persistent"
    class="mx-0 px-0"
    scrollable
  >
    <v-sheet
      class="config-card-overlay bg-background mx-0 px-0"
      color="background"
      density="compact"
      :elevation="0"
    >
      <v-card-title class="config-card-overlay__header">
        <span>{{ title }}</span>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" @click="closeOverlay" />
      </v-card-title>
      <v-card-text class="config-card-overlay__body mx-0 px-0">
        <slot />
      </v-card-text>
    </v-sheet>
  </v-dialog>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component'

@Options({
  props: {
    modelValue: Boolean,
    title: String,
    maxWidth: {
      type: [String, Number],
      default: 960
    },
    persistent: {
      type: Boolean,
      default: true
    }
  },
  emits: ['update:modelValue', 'close']
})
export default class ConfigCardOverlay extends Vue {
  modelValue!: boolean
  title!: string
  maxWidth!: string | number
  persistent!: boolean

  closeOverlay() {
    this.$emit('close')
    this.$emit('update:modelValue', false)
  }
}
</script>

<style scoped lang="scss">
.config-card-overlay {
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.config-card-overlay__header {
  display: flex;
  align-items: center;
  // padding: 12px 16px 0;
  color: rgb(var(--v-theme-on-background));
}

.config-card-overlay__header :deep(.v-btn) {
  color: rgb(var(--v-theme-on-background));
}

.config-card-overlay__body {
  display: flex;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 0 16px 16px !important;
}

.config-card-overlay__body :deep(> *) {
  width: 100%;
}

.config-card-overlay__body :deep(.card) {
  box-shadow: none !important;
}

.config-card-overlay__body :deep(.v-card) {
  box-shadow: none !important;
  overflow-y: auto;
}
</style>
